<div class="adc-d-flex container adc-pl10 adc-pr10" [ngClass]="{'adc-position-absolute': showMore}">
    <div class="adc-dropdown add-filter" #dropdownRef>
        <span class="adc-d-flex adc-gap-2 adc-cursor-pointer adc-align-items-center filter-wrapper" (click)="openAddFilter()">
            <mat-icon>keyboard_arrow_down</mat-icon>
            <p class="adc-m0">Add Filter</p>
        </span>
        <div class="adc-dropdown-option-menu" appendTo="body" *ngIf="showAddFilter">
            <a class="" *ngFor="let filter of filters" (click)="addFilter(filter)" [ngClass]="{'disabled-link': isFilterSelected(filter)}">
                {{ filter.label }}
            </a>
            <!-- @for(filter of defaultFilters?.options; track filter) {
                <a class="" (click)="addFilter(filter)" [ngClass]="{'disabled-link': isFilterSelected(filter)}">
                    {{ filter.label }}
                </a>
            } -->
           
        </div>
    </div>
    <div class="adc-f-grow1 adc-ml10 adc-d-flex adc-align-items-center adc-justify-content-between">
        <div class="adc-d-flex adc-gap-2 adc-align-items-center adc-flex-wrap">
            <div *ngFor="let filter of filterArr; let i = index">
                <div *ngIf="i < 3 || showMore">
                    <span class="filter-trigger">
                        <span (click)="toggleFilterMenu(filter.label)">
                          <span class="adc-d-flex adc-gap-2 adc-align-items-center">
                            <span>{{ filter.label }} {{filter.filterType}}</span>
                            <ng-container class="adc-d-flex adc-gap-2" *ngIf="filter?.selectedValues && filter?.selectedValues?.length > 0; else noFilter">
                              <div class="adc-tag-icon-right" *ngFor="let value of filter.selectedValues; let i = index">
                                <span class="selected-option" title="{{ value }}" *ngIf="filter.type == 'text'">{{ value }}</span>
                                <span class="selected-option" title="{{ value }}" *ngIf="filter.type == 'date' && !value.to"> {{value.from}}</span>
                                <span class="selected-option" title="{{ value }}" *ngIf="filter.type == 'date' && value.to">From {{value.from}} To {{value.to}}</span>
                                <!-- <span class="remove-icon material-symbols-outlined" (click)="removeEachFilter($event, filter, value)">close</span> -->
                                <mat-icon (click)="removeEachFilter($event, filter, value)">close</mat-icon>
                              </div>
                              <div class="adc-tag-icon-right" *ngIf="filter?.selectedValues?.length > maxVisibleValues">
                                <span class="selected-option" title="{{filter.selectedValues.slice(maxVisibleValues).join(',')}}">+{{ filter.selectedValues.length - maxVisibleValues }}</span>
                              </div>
                            </ng-container>
                            <ng-template #noFilter>
                              <a>Click to add filter</a>
                            </ng-template>
                          </span>
                        </span>
                        <!-- <img class="" src="../../../assets/icons/close-icon.svg" alt="" width="15" height="15" (click)="removeFilter(i, filter.id, filter)"> -->
                        <mat-icon (click)="removeFilter(i, filter.id, filter)">close</mat-icon>
                        <adc-filter-popup [filter]="filter" (removeFilterObject)="cancelFilter($event)" (applyFilterObject)="applyFilter($event)"></adc-filter-popup>
                    </span>
                </div>
            </div>
      
          <!-- Show More/Less button -->
          <ng-container *ngIf="filterArr.length > 3">
            <button class="adc-btn adc-btn-primary" (click)="handleShowMore()">
              {{ showMore ? 'Show Less' : 'Show (' + (filterArr.length - 3) + ' more)' }}
            </button>
          </ng-container>
        </div>
      
        <!-- Clear Filter Button -->
        <ng-container *ngIf="filterArr.length > 0">
            <mat-icon (click)="clearFilter()">close</mat-icon>
          <!-- <span class="material-symbols-outlined adc-cursor-pointer" title="Clear Filter" (click)="clearFilter()">close</span> -->
        </ng-container>
      </div>
      
    
    <div class="adc-dropdown create-filter adc-mt2" #dropdownRef2>
        <!-- <svg xmlns="http://www.w3.org/2000/svg" class="adc-cursor-pointer" viewBox="0 0 24 24" width="25" height="25" (click)="openCreateFilter()">
            <title>Add Favourite Filter</title>
            <path d="M12,15.39L8.24,17.66L9.23,13.38L5.91,10.5L10.29,10.13L12,6.09L13.71,10.13L18.09,10.5L14.77,13.38L15.76,17.66M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z" />
        </svg> -->
        <!-- <span class="material-symbols-outlined adc-cursor-pointer" title="Add Favourite Filter" (click)="openCreateFilter()">star</span> -->
        <!-- <mat-icon (click)="openCreateFilter()">star_border</mat-icon> -->
        <div class="adc-dropdown-option-menu adc-rt0" appendTo="body" *ngIf="showCreateFilter">
            <div class="adc-p15">
                <div class="adc-iptgrp-top adc-mb20">
                    <label for="favFilter">Add Favourite Filter</label>
                    <input type="text" id="favFilter" name="favFilter" [(ngModel)]="newFilter">
                </div>
                <div class="adc-d-flex adc-justify-content-between adc-align-items-center">
                    <button class="adc-btn adc-btn-outline-primary adc-btn-sm" (click)="btnClick('cancel')">Cancel</button>
                    <button class="adc-btn adc-btn-primary adc-btn-sm" (click)="btnClick('save')">Save</button>
                </div>
            </div>
        </div>
    </div>
</div>
